import React, { useState } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow, MarkerClusterer } from '@react-google-maps/api';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../../src/Maps.scss'

const MyMapComponent = ({ mapsData }) => {
  // const mapStyles = {
  //   height: '650px',
  //   width: '100%',
  // };

  const navigate = useNavigate();

  const defaultCenter = {
    lat: 37.7749,
    lng: -122.4194,
  };

  const [selectedMarker, setSelectedMarker] = useState(null);
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

  const handleMarkerClick = (marker) => {
    setSelectedMarker(marker);
    navigate(`/assetdetails?assetId=${encodeURIComponent(marker.assetId)}`, { state: { assetName: marker.title, assetId: marker.assetId, customerId: marker.customerId } });
  };

  const handleInfoWindowClose = () => {
    setSelectedMarker(null);
  };

  // Function to group markers based on their latitudes and longitudes
  const groupMarkers = (markers) => {
    const groupedMarkers = {};
    markers.forEach((marker) => {
      const key = `${marker.lat.toFixed(6)}${marker.lng.toFixed(6)}`;
      if (!groupedMarkers[key]) {
        groupedMarkers[key] = [marker];
      } else {
        groupedMarkers[key].push(marker);
      }
    });
    return groupedMarkers;
  };

  // Function to calculate offset for markers within a group
  const calculateOffsets = (markers) => {
    const numMarkers = markers.length;
    const offsets = [];
    if (numMarkers === 1) {
      offsets.push(0);
    } else {
      for (let i = 0; i < numMarkers; i++) {
        offsets.push((i - Math.floor(numMarkers / 2)) * 0.0002); // Adjust the offset as needed
      }
    }
    return offsets;
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div className="map-container" style={{ marginTop: '20px', width: '100%' }}>
      <LoadScript googleMapsApiKey="AIzaSyBdGrNpaLM_WTXPpNGrBjCkTyVk-c9zyOU">
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }} // Ensure map takes full width and height
            zoom={2}
            center={defaultCenter}
          >
            <MarkerClusterer gridSize={60}>
              {(clusterer) => {
                const groupedMarkers = groupMarkers(mapsData);
                const markers = [];
                for (const key in groupedMarkers) {
                  const offsets = calculateOffsets(groupedMarkers[key]);
                  groupedMarkers[key].forEach((marker, index) => {
                    markers.push({
                      ...marker,
                      position: {
                        lat: marker.lat + offsets[index],
                        lng: marker.lng + offsets[index],
                      },
                    });
                  });
                }
                return markers.map((marker) => (
                  <Marker
                    key={`${marker.lat}${marker.lng}`}
                    position={marker.position}
                    title={marker.title}
                    onClick={() => handleMarkerClick(marker)}
                    clusterer={clusterer}
                  />
                ));
              }}
            </MarkerClusterer>
            {selectedMarker && (
              <InfoWindow
                position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
                onCloseClick={handleInfoWindowClose}
              >
                <div>
                  <Link to={`/assetdetails?assetId=${encodeURIComponent(selectedMarker.assetId)}`} state={{ assetId: selectedMarker.assetId, assetName: selectedMarker.title, customerId: selectedMarker.customerId }} style={{ color: 'blue', textDecoration: 'underline' }}>{selectedMarker.title}</Link>
                  <p style={{ color: 'black' }}>{selectedMarker.info}</p>
                </div>
              </InfoWindow>
            )}
          </GoogleMap>
        </LoadScript>
      </div>
    </div>
  )
};

export default MyMapComponent;
